import * as React from 'react';
import { Icon } from 'sos-common/js/components/Icon/icon';
export interface AddItemButtonProps {
  className?: string;
  onClick(e: React.MouseEvent<HTMLButtonElement>): void;
  text: string;
}

export function AddItemButton(props: AddItemButtonProps) {
  return (
    <button className="add" onClick={props.onClick}>
      {props.text} <Icon iconType="baseline-add_circle_outline-24px" /> 
    </button>
  );
}
